// club_name -> home ground name. Covers the traditional "92 Club" (Prem + EFL)
// plus top-flight Scottish sides. Kept in sync with /app/frontend/src/data/clubs.js.
// Used by the Grounds Book to display a name under each crest tile.
export const GROUNDS = {
  // Premier League
  "Arsenal": "Emirates Stadium",
  "Aston Villa": "Villa Park",
  "Bournemouth": "Vitality Stadium",
  "Brentford": "Gtech Community Stadium",
  "Brighton & Hove Albion": "Amex Stadium",
  "Burnley": "Turf Moor",
  "Chelsea": "Stamford Bridge",
  "Crystal Palace": "Selhurst Park",
  "Everton": "Hill Dickinson Stadium",
  "Fulham": "Craven Cottage",
  "Leeds United": "Elland Road",
  "Liverpool": "Anfield",
  "Manchester City": "Etihad Stadium",
  "Manchester United": "Old Trafford",
  "Newcastle United": "St James' Park",
  "Nottingham Forest": "City Ground",
  "Sunderland": "Stadium of Light",
  "Tottenham Hotspur": "Tottenham Hotspur Stadium",
  "West Ham United": "London Stadium",
  "Wolverhampton Wanderers": "Molineux Stadium",

  // Championship
  "Birmingham City": "St Andrew's",
  "Blackburn Rovers": "Ewood Park",
  "Bristol City": "Ashton Gate",
  "Cardiff City": "Cardiff City Stadium",
  "Charlton Athletic": "The Valley",
  "Coventry City": "Coventry Building Society Arena",
  "Derby County": "Pride Park Stadium",
  "Hull City": "MKM Stadium",
  "Ipswich Town": "Portman Road",
  "Leicester City": "King Power Stadium",
  "Middlesbrough": "Riverside Stadium",
  "Millwall": "The Den",
  "Norwich City": "Carrow Road",
  "Oxford United": "Kassam Stadium",
  "Portsmouth": "Fratton Park",
  "Preston North End": "Deepdale",
  "Queens Park Rangers": "Loftus Road",
  "Sheffield United": "Bramall Lane",
  "Sheffield Wednesday": "Hillsborough",
  "Southampton": "St Mary's Stadium",
  "Stoke City": "bet365 Stadium",
  "Swansea City": "Swansea.com Stadium",
  "Watford": "Vicarage Road",
  "West Bromwich Albion": "The Hawthorns",
  "Wrexham": "Racecourse Ground",

  // League One
  "AFC Wimbledon": "Plough Lane",
  "Barnsley": "Oakwell",
  "Blackpool": "Bloomfield Road",
  "Bolton Wanderers": "Toughsheet Community Stadium",
  "Bradford City": "Valley Parade",
  "Burton Albion": "Pirelli Stadium",
  "Doncaster Rovers": "Eco-Power Stadium",
  "Exeter City": "St James Park",
  "Huddersfield Town": "John Smith's Stadium",
  "Leyton Orient": "Brisbane Road",
  "Lincoln City": "LNER Stadium",
  "Luton Town": "Kenilworth Road",
  "Mansfield Town": "One Call Stadium",
  "Northampton Town": "Sixfields Stadium",
  "Peterborough United": "Weston Homes Stadium",
  "Plymouth Argyle": "Home Park",
  "Port Vale": "Vale Park",
  "Reading": "Select Car Leasing Stadium",
  "Rotherham United": "AESSEAL New York Stadium",
  "Stevenage": "Lamex Stadium",
  "Stockport County": "Edgeley Park",
  "Wigan Athletic": "Brick Community Stadium",
  "Wycombe Wanderers": "Adams Park",

  // League Two
  "Accrington Stanley": "Wham Stadium",
  "Barnet": "The Hive Stadium",
  "Barrow": "Holker Street",
  "Bristol Rovers": "Memorial Stadium",
  "Bromley": "Hayes Lane",
  "Cambridge United": "Abbey Stadium",
  "Cheltenham Town": "Whaddon Road",
  "Chesterfield": "SMH Group Stadium",
  "Colchester United": "JobServe Community Stadium",
  "Crawley Town": "Broadfield Stadium",
  "Crewe Alexandra": "Mornflake Stadium",
  "Fleetwood Town": "Highbury Stadium",
  "Gillingham": "Priestfield Stadium",
  "Grimsby Town": "Blundell Park",
  "Harrogate Town": "EnviroVent Stadium",
  "Milton Keynes Dons": "Stadium MK",
  "Newport County": "Rodney Parade",
  "Notts County": "Meadow Lane",
  "Oldham Athletic": "Boundary Park",
  "Salford City": "Peninsula Stadium",
  "Shrewsbury Town": "Croud Meadow",
  "Swindon Town": "County Ground",
  "Tranmere Rovers": "Prenton Park",
  "Walsall": "Bescot Stadium",

  // Scottish Premiership (top 5)
  "Celtic": "Celtic Park",
  "Rangers": "Ibrox Stadium",
  "Hibernian": "Easter Road",
  "Heart of Midlothian": "Tynecastle Park",
  "Aberdeen": "Pittodrie Stadium",
};

// The "92 Club" — English top four tiers only. Used as the default filter on the
// grounds picker so users don't have to scroll through the Nat League as well.
export const NINETY_TWO_LEAGUES = new Set([
  "Premier League", "Championship", "League One", "League Two",
]);
